<template>
  <div>
    <vx-card>
      <ContentSidebar
        :isSidebarActive="isSidebarActive"
        @refreshData="toggleRefreshData"
        @closeSidebar="toggleDataSidebar"
        :data="sidebarData"
        :dataId="dataId"
      />

      <div class="mb-8 md:flex">
        <h2 class="mb-0">Content List</h2>
        <div class="vx-col md:w-1/4 w-full md:ml-auto" align="left">
          <vs-input
            class="w-full search-input"
            v-model="searchQuery"
            placeholder="Search..."
          />
        </div>
      </div>

      <div id="data-list-list-view" class="data-list-container">
        <vs-table
          ref="table"
          :sst="true"
          :total="totalDocs"
          :data="contents"
          @search="handleSearch"
          @change-page="handleChangePage"
          @sort="handleSort"
          :max-items="dataTableParams.limit"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse flex-grow justify-between mb-5"
          >
            <div style="float: left">
              <vs-select
                placeholder="10"
                vs-multiple
                autocomplete
                v-model="dataTableParams.limit"
                label="display per page"
                class="mr-6"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in limitOptions"
                  :clearable="false"
                />
              </vs-select>
            </div>
          </div>

          <template slot="thead">
            <vs-th>Content Name</vs-th>
            <vs-th>Type</vs-th>
            <vs-th class="action-col justify-center">Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.name">
                {{ tr.name | capitalize }}
              </vs-td>
              <vs-td :data="tr.contentType">
                {{ tr.contentType | capitalize }}
              </vs-td>
              <vs-td :data="tr._id" class="text-center">
                <a href="#" @click.stop="editDetailHandler(tr, tr._id)">
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  />
                </a>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="m-2" v-if="contents.length > 0">
          <span class="mr-2">
            {{
              dataTableParams.page * dataTableParams.limit -
                (dataTableParams.limit - 1)
            }}
            -
            {{
              totalDocs - dataTableParams.page * dataTableParams.limit > 0
                ? dataTableParams.page * dataTableParams.limit
                : totalDocs
            }}
            of {{ totalDocs }}
          </span>
          <div class="pagination-div" v-if="serverResponded">
            <paginate
              :page-count="totalPage"
              :click-handler="handleChangePage"
              class="pagination"
              :page-range="9"
              :prevText="'<'"
              :nextText="'>'"
            ></paginate>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapActions } from "vuex";
import ContentSidebar from "./contentSidebar";

export default {
  components: {
    "v-select": vSelect,
    ContentSidebar
  },
  data() {
    return {
      searchQuery: "",
      isMounted: false,
      totalDocs: 0,
      currentPage: 1,
      dataTableParams: {
        search: "",
        sort: "name",
        dir: "asc",
        page: 1,
        limit: 10
      },
      serverResponded: false,
      contents: [],
      limitOptions: [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "100", value: 100 }
      ],
      //add story sidebar
      isSidebarActive: false,
      sidebarData: {},
      dataId: "",
      awaitingSearch: false
    };
  },
  methods: {
    ...mapActions("setting", ["fetchContent"]),
    getContentList() {
      this.dataTableParams.search = this.searchQuery;
      this.fetchContent(this.dataTableParams).then(res => {
        this.contents = res.data.data.docs;
        this.totalDocs = res.data.data.pagination.total;
        this.page = res.data.data.pagination.page;
      });
      this.serverResponded = true;
    },
    handleSearch(searching) {
      this.serverResponded = false;
      this.dataTableParams.search = searching;
      this.dataTableParams.page = 1;
      this.$refs.table.currentx = 1;
      this.getContentList();
    },
    handleChangePage(page) {
      this.dataTableParams.page = page;
      this.getContentList();
    },
    handleSort(key, active) {
      this.serverResponded = false;
      this.dataTableParams.sort = key;
      this.dataTableParams.dir = active;
      this.dataTableParams.page = 1;
      this.$refs.table.currentx = 1;
      this.getContentList();
    },
    editDetailHandler(data, id) {
      this.sidebarData = data;
      this.dataId = id;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.isSidebarActive = val;
    },
    toggleRefreshData(val = false) {
      if (val) {
        this.getContentList();
      }
    }
  },
  watch: {
    "dataTableParams.page": function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dataTableParams.page = newVal;
        this.getContentList();
      }
    },
    "dataTableParams.limit": function(newlimit, oldLimit) {
      if (newlimit !== oldLimit) {
        this.serverResponded = false;
        this.dataTableParams.page = 1;
        this.dataTableParams.limit = newlimit;
        this.getContentList();
      }
    },
    searchQuery: function() {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.getContentList();
          this.awaitingSearch = false;
        }, 1000); // 1 sec delay
      }
      this.awaitingSearch = true;
    }
  },
  computed: {
    totalPage: function() {
      return this.totalDocs / this.dataTableParams.limit >
        parseInt(this.totalDocs / this.dataTableParams.limit)
        ? parseInt(this.totalDocs / this.dataTableParams.limit) + 1
        : parseInt(this.totalDocs / this.dataTableParams.limit);
    }
  },
  created() {
    this.getContentList();
  }
};
</script>
